import '@less/index.less'
import '@sass/index.sass'
import { buildApp } from './app.js'

const { app, router, store } = buildApp(window.ENV_VAR)

const storeInitialState = window.INITIAL_DATA
if (storeInitialState) {
  store.replaceState(storeInitialState)
}

router.isReady().then(() => {
  app.mount('#app', true)
})
